module.exports = __webpack_public_path__ + "static/media/arrow.176297df.svg";